import NumberInput from './NumberInput'

function CurrencyInput({
    inputProps,
    label,
    name,
    value,
    onCommit,
    disabled,
    currencyType = "USD"
}) {
  return (
    <NumberInput
        inputProps={inputProps}
        label={label}
        name={name}
        value={value}
        onCommit={onCommit}
        disabled={disabled}
        startSymbol="$"
        unit={currencyType}
        isFloat={true}
        isCurrency={true}
    />
  )
}

export default CurrencyInput